/* eslint-disable tsdoc/syntax,@typescript-eslint/no-explicit-any -- not needed */
// Reference: https://github.com/scopsy/await-to-js

/**
 * @param {Promise} promise
 * @param {Object} errorExt - Additional Information you can pass to the err object
 * @return {Promise}
 */
export function tryCatch<T, U = Error>(
  promise: Promise<T>,
  errorExt?: object,
): Promise<[U, undefined] | [null, T]> {
  return promise
    .then<[null, T]>((data: T) => [null, data])
    .catch<[U, undefined]>((err: U) => {
      if (errorExt) {
        Object.assign(err as any, errorExt);
      }

      return [err, undefined];
    });
}
